import type { OffersPageThemedBox } from '@trmediaab/zebra';

const box: OffersPageThemedBox = {
  variants: {
    offersPageHeader: {
      mx: 'auto',
      textAlign: [null, null, 'center'],
    },
  },
};

export default box;
